<template>
  <q-page>
    <iframe src="ClimbICP_Website%20Terms%20and%20Conditions_17%20June%202019.pdf" class="absolute">
    </iframe>
  </q-page>
</template>

<script>
export default {
  name: 'PageTermsAndConditions'
}
</script>

<style lang="stylus">
  iframe {
    display: block;       /* iframes are inline by default */
    background: #000;
    border: none;         /* Reset default border */
    height: 100%;        /* Viewport-relative units */
    width: 100%;
  }
  .q-page {
    height: 100%
  }
</style>
